import { render, staticRenderFns } from "./CarriersList.vue?vue&type=template&id=39db59c2&scoped=true"
import script from "./CarriersList.vue?vue&type=script&lang=js"
export * from "./CarriersList.vue?vue&type=script&lang=js"
import style0 from "./CarriersList.vue?vue&type=style&index=0&id=39db59c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db59c2",
  null
  
)

export default component.exports